import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { NAV_LINKS } from '@/constants/site'
import { ThemeToggle } from '@/components/generals/theme-toggle'

export const SiteHeader: FC = (): ReactNode => {
    const router = useRouter()
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const onScroll = (): void => setScrolled(window.scrollY > 24)

        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })

        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <header className='mo-header' data-scrolled={scrolled}>
            <Link href='/' className='mo-logo' aria-label='Morph, home'>
                MORPH
            </Link>

            <div className='mo-nav'>
                <nav className='mo-nav' aria-label='Primary'>
                    {NAV_LINKS.map((link) => (
                        <Link
                            key={link.href}
                            href={link.href}
                            className='mo-navlink'
                            data-active={router.pathname === link.href}
                            aria-current={router.pathname === link.href ? 'page' : undefined}
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                <ThemeToggle />
            </div>
        </header>
    )
}
